import { FaTimesCircle } from "react-icons/fa";
import { converterDataHoraBr } from "_utils/Data";
import {
  ContainerIcone,
  ContainerModalStatusErro,
  ModalErroMensagem,
  ModalErroTitulo,
  ModalInfoItem,
  ModalInfoRow,
} from "./style";

interface IDados {
  dataSolicitacao: Date;
  tipo: string;
  mensagem: string;
}

interface IProps {
  show: boolean;
  coords: { top: number; left: number };
  dados: IDados;
}

export function ModalStatusErro({ show, coords, dados }: IProps) {
  if (!show) return null;

  const tipoFormatado =
    dados.tipo === "bloquear"
      ? "Bloqueio"
      : dados.tipo === "desbloquear"
        ? "Desbloqueio"
        : "--";

  return (
    <ContainerModalStatusErro top={coords.top} left={coords.left}>
      <ModalInfoRow>
        <ModalInfoItem>
          <small>Data solicitação</small>
          <span>{converterDataHoraBr(dados.dataSolicitacao)}</span>
        </ModalInfoItem>
        <ModalInfoItem>
          <small>Solicitação</small>
          <span>{tipoFormatado}</span>
        </ModalInfoItem>
      </ModalInfoRow>
      <ModalErroTitulo>
        <ContainerIcone>
          <FaTimesCircle size={14} />
        </ContainerIcone>
        Erro
      </ModalErroTitulo>
      <ModalErroMensagem>{dados.mensagem}</ModalErroMensagem>
    </ContainerModalStatusErro>
  );
}
